import classNames from 'classnames'
import React, { useMemo } from 'react'

interface IBar {
  color: string
  colorVacant: string
  percent: number
  className?: string
}

export default function Bar(props: IBar) {
  const { color, colorVacant, percent, className } = props
  const computedPercent = useMemo(() => {
    if (percent < 0) {
      return 0
    } else if (percent > 100) {
      return 100
    } else {
      return percent
    }
  }, [percent])
  return (
    <div className={classNames(className, 'bar')}>
      <span className="fill" />
      <span className="vacant" />
      <style jsx>
        {`
          .bar {
            width: 100%;
            height: 100%;
            display: flex;
          }
          .fill {
            width: ${computedPercent}%;
            height: 100%;
            background-color: ${color};
          }
          .vacant {
            width: ${100 - computedPercent}%;
            height: 100%;
            background-color: ${colorVacant};
          }
        `}
      </style>
    </div>
  )
}
